import React, { useEffect } from 'react'
import { Head } from '@notino/react-toolkit/exports/Head'

// hooks
import useMessages from '../../../../hooks/useMessages'

type MyPassPageHeadProps = {
	serviceName?: string
}

const MyPassPageHead = (props: MyPassPageHeadProps) => {
	const { serviceName } = props
	const { messages } = useMessages()
	const pageTitle = serviceName ?? messages['My pass']

	useEffect(() => {
		document.title = pageTitle
	}, [pageTitle])

	const children = [<title key='title'>{pageTitle}</title>, <meta key='robots' name='robots' content='noindex, nofollow' />].flat().filter(Boolean)

	return <Head>{children}</Head>
}

export default MyPassPageHead
